import { Text } from '../../Text/Text';
import { TextLoader } from '../../Text/TextLoader';

export const SelectedSpeciesText = ({
  selectedSpeciesName,
  isLoading,
}: {
  selectedSpeciesName?: string;
  isLoading: boolean;
}) => {
  if (isLoading) {
    return (
      <TextLoader
        backgroundColor="#e5e7eb"
        foregroundColor="#d1d5db"
        uniqueKey="selected-species-loader"
        variant="none"
        width={120}
      />
    ); // Adjust width as needed
  }
  return (
    <Text as="span" variant="none">
      {selectedSpeciesName}
    </Text>
  );
};
